import type {
  ServiceGetAllResponse,
  ServiceMutationOptionType,
  ServiceQueryOptionType
} from '@/types/service'

import { api, handleAxiosError } from '@/lib/axios'

import type { PindahDomisiliDataType } from './types'
import type {
  ApprovePindahDomisiliValues,
  FilterPindahDomisiliValues
} from './validation'

const PINDAH_DOMISILI_QUERY_KEY = (key?: string | Record<string, any>) =>
  ['pindah-domisili', key] as const

const getAll = (
  params?: FilterPindahDomisiliValues
): ServiceQueryOptionType<
  ServiceGetAllResponse<Array<PindahDomisiliDataType>>
> => ({
  queryKey: PINDAH_DOMISILI_QUERY_KEY(params),
  queryFn: async () => {
    try {
      const response = await api.get<
        ServiceGetAllResponse<Array<PindahDomisiliDataType>>
      >('/kelembagaan/domisili-logs', {
        params: {
          page: params?.page,
          per_page: params?.per_page,
          search: params?.search,
          status: params?.status === 'all' ? undefined : params?.status
        }
      })

      return response.data
    } catch (error) {
      throw handleAxiosError(error)
    }
  }
})

const getById = (
  id: string
): ServiceQueryOptionType<{ data: PindahDomisiliDataType }> => ({
  queryKey: PINDAH_DOMISILI_QUERY_KEY(id),
  queryFn: async () => {
    try {
      const response = await api.get<{ data: PindahDomisiliDataType }>(
        `/kelembagaan/domisili-logs/${id}`
      )

      return response.data
    } catch (error) {
      throw handleAxiosError(error)
    }
  }
})

const approveData = (): ServiceMutationOptionType<
  { message: string },
  ApprovePindahDomisiliValues
> => ({
  mutationFn: async (data: ApprovePindahDomisiliValues) => {
    try {
      const payload: Record<string, string> = {
        status: data.status
      }

      // Tambahkan approved_notes jika status rejected
      if (data.status === 'rejected' && data.alasan_penolakan) {
        payload.approved_notes = data.alasan_penolakan
      }

      const response = await api.post<{ message: string }>(
        `/kelembagaan/domisili-logs/${data.id}`,
        payload
      )

      return response.data
    } catch (error) {
      throw handleAxiosError(error)
    }
  }
})

export const pindahDomisili = {
  queryKey: ['pindah-domisili'],
  getAll,
  getById,
  approveData
}
